import { AIR_API_CONFIG } from '@air/utils-auth';

const cypressAirApiConfig = {
  baseUrl: typeof Cypress === 'undefined' ? '' : Cypress.env('NEXT_PUBLIC_API_ENDPOINT'),
  wsUrl: typeof Cypress === 'undefined' ? '' : Cypress.env('NEXT_PUBLIC_WS_URL'),
};

export const getAirApiConfig = () => (typeof Cypress === 'undefined' ? AIR_API_CONFIG : cypressAirApiConfig);
